import axios from 'axios';

const Json2XmlConverter = require('xml-js');

function textOverFlowAdjustment(element) {
  if (element.offsetHeight < 20 || element.offsetWidth < 20) {
    return element;
  }

  while (element.clientHeight > element.firstElementChild.firstElementChild.offsetHeight) {
    element.style.fontSize = `${parseFloat(element.style.fontSize) + 0.1}px`;
  }


  while (element.clientHeight < element.firstElementChild.firstElementChild.offsetHeight) {
    element.style.fontSize = `${parseFloat(element.style.fontSize) - 0.1}px`;
  }
  return element;
}

function applyLineHeightToEachTag(allSpans) {
  for (let spanIndex = 0; spanIndex < allSpans.length; spanIndex++) {
    allSpans[spanIndex].style.lineHeight = `${parseFloat(allSpans[spanIndex].style.fontSize) + this.data.LineSpacing}px`;
  }
  return allSpans;
}
function decreaseFontSize(allSpans, max) {
  for (let i = 0; i < allSpans.length; i++) {
    if (allSpans[i].style.fontSize === '') {
      continue;
    }
    allSpans[i].style.fontSize   = `${parseFloat(allSpans[i].style.fontSize) - parseFloat(allSpans[i].style.fontSize) / max}px`;
    allSpans[i].style.lineHeight = `${parseFloat(allSpans[i].style.fontSize) + this.data.LineSpacing}px`;
  }
  return allSpans;
}
function findMaxFont(allSpans) {
  let maxFontSize = parseFloat(allSpans[0].style.fontSize);
  for (let i = 1; i < allSpans.length; i++) {
    if (parseFloat(allSpans[i].style.fontSize) > maxFontSize) {
      maxFontSize = parseFloat(allSpans[i].style.fontSize);
    }
  }
  return maxFontSize;
}
function rgbToCmyk(RGB) {
  if (typeof RGB === 'string') {
    const strArray = RGB.split(',');
    strArray[0]    = Number(strArray[0].slice(4));
    strArray[1]    = Number(strArray[1]);
    strArray[2]    = Number(strArray[2].slice(0, -1));
    RGB            = {
      r: strArray[0],
      g: strArray[1],
      b: strArray[2],
    };
  }
  let c = 0;
  let m = 0;
  let y = 0;
  let k = 0;

  const r = RGB.r / 255;
  const g = RGB.g / 255;
  const b = RGB.b / 255;

  k = Math.min(1 - r, 1 - g, 1 - b);
  c = (1 - r - k) / (1 - k);
  m = (1 - g - k) / (1 - k);
  y = (1 - b - k) / (1 - k);

  c = Math.round(c * 100);
  m = Math.round(m * 100);
  y = Math.round(y * 100);
  k = Math.round(k * 100);
  // return {
  //   c: c,
  //   m: m,
  //   y: y,
  //   k: k
  // }
  return `cmyk(${c}% ${m}% ${y}% ${k}%)`;
}
function hexToCMYK(hex) {
  let computedC = 0;
  let computedM = 0;
  let computedY = 0;
  let computedK = 0;

  hex = (hex.charAt(0) == '#') ? hex.substring(1, 7) : hex;

  if (hex.length != 6) {
    // alert ('Invalid length of the input hex value!');
    return;
  }
  if (/[0-9a-f]{6}/i.test(hex) != true) {
    // alert ('Invalid digits in the input hex value!');
    return;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // BLACK
  if (r == 0 && g == 0 && b == 0) {
    computedK = 1;
    return [0, 0, 0, 1];
  }

  computedC = 1 - (r / 255);
  computedM = 1 - (g / 255);
  computedY = 1 - (b / 255);

  const minCMY = Math.min(computedC, Math.min(computedM, computedY));

  computedC = (computedC - minCMY) / (1 - minCMY);
  computedM = (computedM - minCMY) / (1 - minCMY);
  computedY = (computedY - minCMY) / (1 - minCMY);
  computedK = minCMY;
  return `cmyk(${computedC}% ${computedM}% ${computedY}% ${computedK}%)`;
}
function cmykToHex(cmyk) {
  cmyk          = cmyk.replace('cmyk(', '');
  cmyk          = cmyk.replace(')', '');
  cmyk          = cmyk.replace(/%/g, '');
  const cmykArr = cmyk.split(' ');


  let c = parseInt(cmykArr[0]);
  let m = parseInt(cmykArr[1]);
  let y = parseInt(cmykArr[2]);
  let k = parseInt(cmykArr[3]);


  c             = DectoHex(c);
  m             = DectoHex(m);
  y             = DectoHex(y);
  k             = DectoHex(k);
  const cmykHex = `#${c}${m}${y}${k}`;

  return cmykHex;
}
function convertingDifferentMeasurementUnitIntoPx(data) {
  const value = String(data == null ? '' : data);
  const temp  = parseInt(value, 10);
  if (value.endsWith('m')) { return Math.round(temp * 3.77); }
  if (value.endsWith('t')) { return Math.round(temp * 1.33333); }
  return temp;
}

function isFDICEHNCUA(imageType) {
  return typeof imageType === 'string'
      && (imageType.indexOf('FDICLogo') !== -1 || imageType.indexOf('FDICText') !== -1);
}

function extractSvgSizeFromContent(svgContent) {
  if (!svgContent) {
    return { width: null, height: null };
  }
  const widthMatch  = svgContent.match(/<svg\b[^>]*\bwidth="([^"]+)"/i);
  const heightMatch = svgContent.match(/<svg\b[^>]*\bheight="([^"]+)"/i);
  return {
    width:  widthMatch ? widthMatch[1] : null,
    height: heightMatch ? heightMatch[1] : null,
  };
}

function getSvgScaleToFitBox(boxWidth, boxHeight, svgWidthAttr, svgHeightAttr, uniform) {
  const nativeWidth  = convertingDifferentMeasurementUnitIntoPx(svgWidthAttr);
  const nativeHeight = convertingDifferentMeasurementUnitIntoPx(svgHeightAttr);
  let scaleX         = nativeWidth ? (boxWidth / nativeWidth) : 1;
  let scaleY         = nativeHeight ? (boxHeight / nativeHeight) : 1;
  scaleX             = scaleX || 1;
  scaleY             = scaleY || 1;
  if (uniform) {
    const scale = Math.min(scaleX, scaleY) || 1;
    scaleX      = scale;
    scaleY      = scale;
  }
  return {
    scaleX,
    scaleY,
    nativeWidth,
    nativeHeight,
    width:  nativeWidth * scaleX,
    height: nativeHeight * scaleY,
  };
}

function applySvgScaleTransform(svgContent, scaleX, scaleY) {
  if (!svgContent) {
    return svgContent;
  }
  const newStyles = `transform-origin: left top; transform: scale(${scaleX}, ${scaleY})`;

  const parseStyle = (styleStr) => {
    const styleObj = {};
    String(styleStr || '').split(';').forEach((part) => {
      const [key, value] = part.split(':').map(s => s && s.trim());
      if (key && value) { styleObj[key] = value; }
    });
    return styleObj;
  };

  const styleMatch    = svgContent.match(/<svg[^>]*style="([^"]*)"/);
  const existingStyle = styleMatch ? styleMatch[1] : '';
  const mergedObj     = { ...parseStyle(existingStyle), ...parseStyle(newStyles) };
  const mergedStyleString = Object.entries(mergedObj)
      .map(([k, v]) => `${k}: ${v}`)
      .join('; ');

  if (styleMatch) {
    return svgContent.replace(
        /<svg([^>]*)style="[^"]*"([^>]*)>/,
        `<svg$1style="${mergedStyleString}"$2>`,
    );
  }

  return svgContent.replace(
      /<svg([^>]*)>/,
      `<svg$1 style="${mergedStyleString}">`,
  );
}

function fitLogoToBox(object, svgWidthAttr, svgHeightAttr, pageSize) {
  const fit = getSvgScaleToFitBox(object.Width, object.Height, svgWidthAttr, svgHeightAttr, true);
  if (!isFinite(fit.width) || !isFinite(fit.height) || fit.width <= 0 || fit.height <= 0) {
    return fit;
  }
  if (pageSize && pageSize.width && pageSize.height) {
    const distLeft   = object.X;
    const distRight  = pageSize.width - (object.X + object.Width);
    const distTop    = object.Y;
    const distBottom = pageSize.height - (object.Y + object.Height);
    if (distRight < distLeft) {
      object.X += object.Width - fit.width;
    }
    if (distBottom < distTop) {
      object.Y += object.Height - fit.height;
    }
  }
  object.Width  = fit.width;
  object.Height = fit.height;
  if (object.SvgProperty) {
    object.SvgProperty.svgScaleX = fit.scaleX;
    object.SvgProperty.svgScaleY = fit.scaleY;
    object.SvgProperty.style     = `scale(${fit.scaleX}, ${fit.scaleY})`;
  }
  return fit;
}

function applyLogoFitFromContent(object, svgContent, pageSize, fallbackWidth, fallbackHeight) {
  const size      = extractSvgSizeFromContent(svgContent);
  const svgWidth  = size.width || fallbackWidth;
  const svgHeight = size.height || fallbackHeight;
  if (!svgContent || !svgWidth || !svgHeight) {
    return svgContent;
  }
  const fit = fitLogoToBox(object, svgWidth, svgHeight, pageSize);
  if (!fit || !isFinite(fit.scaleX) || !isFinite(fit.scaleY)) {
    return svgContent;
  }
  return applySvgScaleTransform(svgContent, fit.scaleX, fit.scaleY);
}
function fetchingSvgBk(url) {
  return axios
      .get(url)
      .then(async (response) => {
        const svgData    = await response.data;
        const parser     = new DOMParser();
        const doc        = parser.parseFromString(svgData, 'image/svg+xml');
        const svgElement = doc.getElementsByTagName('svg')[0];
        let viewBox      = svgElement.getAttribute('viewBox');
        viewBox          = viewBox.split(' ');
        !svgElement.getAttribute('fill') && svgElement.setAttribute('fill', 'rgb(0,0,0)');
        !svgElement.getAttribute('width') && viewBox[2] && svgElement.setAttribute('width', viewBox[2]);
        !svgElement.getAttribute('height') && viewBox[3] && svgElement.setAttribute('height', viewBox[3]);
        if (svgElement.firstElementChild.tagName.toLowerCase() === 'style') {
          svgElement.removeChild(svgElement.firstElementChild);
        }
        const lines = svgElement.getElementsByTagName('line');
        if (lines.length) {
          for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
            lines[lineIndex].style.stroke = '#000000';
          }
        }
        svgElement.style.transformOrigin = 'left top';
        //  this.handleModalClose();
        //   EventBus.$emit('AddSvgShape', {
        //     content: svgElement.outerHTML, name:    this.selectedShape.name, color:   'rgb(0,0,0)', width:   svgElement.getAttribute('width'), height:  svgElement.getAttribute('height'),
        //   });
        return {
          content: svgElement.outerHTML, color:   'rgb(0,0,0)', width:   svgElement.getAttribute('width'), height:  svgElement.getAttribute('height'),
        };
      });
}

async function fetchingSvg(url) {
  console.log('New Fetch SVG');
  const response = await fetch(url);
  const svgData  = await response.text();

  const parser     = new DOMParser();
  const doc        = parser.parseFromString(svgData, 'image/svg+xml');
  const svgElement = doc.getElementsByTagName('svg')[0];

  let viewBox = svgElement.getAttribute('viewBox');
  viewBox     = viewBox ? viewBox.split(' ') : [];

  if (!svgElement.getAttribute('fill')) {
    svgElement.setAttribute('fill', 'rgb(0,0,0)');
  }

  if (!svgElement.getAttribute('width') && viewBox[2]) {
    svgElement.setAttribute('width', viewBox[2]);
  }

  if (!svgElement.getAttribute('height') && viewBox[3]) {
    svgElement.setAttribute('height', viewBox[3]);
  }

  if (svgElement.firstElementChild && svgElement.firstElementChild.tagName.toLowerCase() === 'style') {
    svgElement.removeChild(svgElement.firstElementChild);
  }

  const lines = svgElement.getElementsByTagName('line');
  for (let i = 0; i < lines.length; i++) {
    lines[i].style.stroke = '#000000';
  }

  svgElement.style.transformOrigin = 'left top';

  return {
    content: svgElement.outerHTML,
    color:   'rgb(0,0,0)',
    width:   svgElement.getAttribute('width'),
    height:  svgElement.getAttribute('height'),
  };
}

function DectoHex(d) {
  return (`0${Number(d).toString(16)}`).slice(-2).toUpperCase();
}
function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length == 1 ? `0${hex}` : hex;
}

function rgbToHex(rgb) {
  rgb     = rgb.split(',');
  const r = parseInt((rgb[0].replace('rgb(', '')).trim());
  const g = parseInt((rgb[1].replace('rgb(', '')).trim());
  const b = parseInt((rgb[2].replace(')', '')).trim());

  return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
}

function hexToRgb(hex) {
  hex          = hex.toUpperCase();
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? `rgb(${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)})` : null;
}

function getMaxZIndex(elements) {
  let maxZIndex = 0;
  for (let elementIndex = 0; elementIndex < elements.length; elementIndex++) {
    const elementZIndex = parseInt(elements[elementIndex].style.zIndex);
    if (elementZIndex > maxZIndex) {
      maxZIndex = elementZIndex;
    }
  }
  return maxZIndex;
}

function helperFunctionToSortByObjectKey(prop) {
  return function (a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  };
}
function helperFunctionToReverseSortByObjectKey(prop) {
  return function (a, b) {
    if (a[prop] < b[prop]) {
      return 1;
    } if (a[prop] > b[prop]) {
      return -1;
    }
    return 0;
  };
}

function convertJson2Xml(jsonObj) {
  if (!jsonObj) { return ''; }
  const convert = require('xml-js');
  const options = {
    space:               0,
    compact:             true,
    fullTagEmptyElement: true,
    indentCdata:         false,
    indentAttributes:    false,
    ignoreDeclaration:   false,
    ignoreInstruction:   false,
    ignoreAttributes:    false,
    ignoreComment:       false,
    ignoreCdata:         false,
    ignoreDoctype:       false,
    ignoreText:          false,
  };

  return convert.js2xml(jsonObj, options);
}

async function removeBackground(imageUrl) {
  try {
    const apiUrl = `https://processor.gangifyapp.com/api/removeBg?image=${encodeURIComponent(imageUrl)}`;

    const response = await fetch(apiUrl, {
      method:  'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('API Error:', error);
  }
}
function parseRgb(value) {
  const match = value.match(
      /^rgb\(\s*([0-9.]+%?)\s*,\s*([0-9.]+%?)\s*,\s*([0-9.]+%?)\s*\)$/i
  );

  if (!match) return null;

  return match.slice(1).map(channel => {
    if (channel.endsWith('%')) {
      return parseFloat(channel) * 2.55;
    }

    return parseFloat(channel);
  });
}


function parseColorToRgb(value) {
  if (!value) {
    return null;
  }
  const v = value.trim().toLowerCase();
  if (v === 'white') {
    return [255, 255, 255];
  }
  const hex6 = v.match(/^#([0-9a-f]{6})$/);
  if (hex6) {
    return [
      parseInt(hex6[1].slice(0, 2), 16),
      parseInt(hex6[1].slice(2, 4), 16),
      parseInt(hex6[1].slice(4, 6), 16),
    ];
  }
  const hex3 = v.match(/^#([0-9a-f]{3})$/);
  if (hex3) {
    return hex3[1].split('').map(ch => parseInt(ch + ch, 16));
  }
  return parseRgb(value);
}

function isWhiteColor(value, darknessThreshold = 140, colorVariance = 35) {
  const rgb = parseColorToRgb(value);
  if (!rgb) return false;
  const [r, g, b] = rgb;
  const brightness = (r + g + b) / 3;
  const variance   = Math.max(r, g, b) - Math.min(r, g, b);

  return (
      brightness >= darknessThreshold &&
      variance <= colorVariance
  );
}

function isInvisibleOnWhite(value) {
  if (isWhiteColor(value)) {
    return true;
  }
  const rgb = parseColorToRgb(value);
  if (!rgb) {
    return false;
  }
  const [r, g, b] = rgb;
  const brightness = (r + g + b) / 3;
  const minC       = Math.min(r, g, b);
  return brightness >= 190 && minC >= 70 && Math.min(r, g) >= 170;
}

function getSvgFillValues(style) {
  if (!style) {
    return [];
  }
  const values = [];
  const re     = /(?:^|;)\s*fill\s*:\s*([^;]+)/gi;
  let match    = re.exec(style);
  while (match) {
    const value = match[1].trim().toLowerCase();
    if (value && value !== 'none' && value !== 'transparent' && value !== 'inherit') {
      values.push(match[1].trim());
    }
    match = re.exec(style);
  }
  return values;
}

function collectElementFills(el) {
  const fills = getSvgFillValues(el.getAttribute('style'));
  const attr  = el.getAttribute('fill');
  if (attr) {
    const value = attr.trim().toLowerCase();
    if (value && value !== 'none' && value !== 'transparent' && value !== 'inherit') {
      fills.push(attr.trim());
    }
  }
  return fills;
}

function isFullBleedBackgroundRect(el, svg) {
  const tag = (el.tagName || '').toLowerCase();
  if (tag !== 'rect') {
    return false;
  }
  const vb     = svg.viewBox && svg.viewBox.baseVal;
  const svgW   = parseFloat(svg.getAttribute('width')) || (vb && vb.width) || 0;
  const svgH   = parseFloat(svg.getAttribute('height')) || (vb && vb.height) || 0;
  const rectW  = parseFloat(el.getAttribute('width'));
  const rectH  = parseFloat(el.getAttribute('height'));
  if (!svgW || !svgH || Number.isNaN(rectW) || Number.isNaN(rectH)) {
    return false;
  }
  return rectW >= svgW * 0.95 && rectH >= svgH * 0.95;
}

async function extractSvgColors(url) {
  const response = await fetch(url);
  const svgText  = await response.text();
  if (svgText.includes('<image')) {
    return false;
  }
  const parser = new DOMParser();
  const doc    = parser.parseFromString(svgText, 'image/svg+xml');
  const svg    = doc.querySelector('svg') || doc.documentElement;

  const nodes = doc.querySelectorAll('[style], [fill]');
  for (let i = 0; i < nodes.length; i += 1) {
    const el = nodes[i];
    if (isFullBleedBackgroundRect(el, svg)) {
      continue;
    }
    const fills = collectElementFills(el);
    for (let j = 0; j < fills.length; j += 1) {
      if (isInvisibleOnWhite(fills[j])) {
        return true;
      }
    }
  }
  return false;
}
const blurMaskCache = new Map();

function getBlurMaskBlob(width, height) {
  const key = `${width}_${height}`;
  if (blurMaskCache.has(key)) {
    return Promise.resolve(blurMaskCache.get(key));
  }

  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');
    const ctx    = canvas.getContext('2d');

    canvas.width  = width;
    canvas.height = height;

    const w = width;
    const h = height;

    const blurWidth = 0.2;
    const stop2     = 0.98;
    const stop1     = stop2 - blurWidth;

    const drawGradient = (isVertical) => {
      const grad = isVertical
          ? ctx.createLinearGradient(0, 0, 0, h)
          : ctx.createLinearGradient(0, 0, w, 0);

      grad.addColorStop(0, 'rgba(0,0,0,0)');
      grad.addColorStop(1 - stop2, 'rgba(0,0,0,0)');
      grad.addColorStop(1 - stop1, 'rgba(0,0,0,1)');

      grad.addColorStop(0.5, 'rgba(0,0,0,1)');

      grad.addColorStop(stop1, 'rgba(0,0,0,1)');
      grad.addColorStop(stop2, 'rgba(0,0,0,0)');
      grad.addColorStop(1, 'rgba(0,0,0,0)');

      return grad;
    };

    // Vertical gradient
    ctx.fillStyle = drawGradient(true);
    ctx.fillRect(0, 0, w, h);

    // Intersect with horizontal
    ctx.globalCompositeOperation = 'destination-in';
    ctx.fillStyle                = drawGradient(false);
    ctx.fillRect(0, 0, w, h);

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      blurMaskCache.set(key, url);
      resolve(url);
    }, 'image/png');
  });
}
function decodeStoredHtml(value) {
  if (typeof value !== 'string' || value.length === 0) {
    return value;
  }

  let  decoded = value;
  try {
    decoded = decodeURIComponent(decoded);
  } catch (e) {
    console.log("error", e)
  }
  console.log("decoded", decoded)
  const isHTML = /<[^>]+>/.test(decoded);
  if (isHTML) {
    return decoded;
  }

  if (!decoded.includes('&')) {
    return decoded;
  }

  const textarea     = document.createElement('textarea');
  textarea.innerHTML = decoded;
  return textarea.value;
}
function removeInlineColorsFromNode(node) {
  if (!node) {
    return node;
  }

  node.querySelectorAll('[style]').forEach((el) => {
    const updated = el.getAttribute('style')
        .split(';')
        .map(declaration => declaration.trim())
        .filter(declaration => declaration && declaration.split(':')[0].trim().toLowerCase() !== 'color')
        .join('; ');

    if (updated) {
      el.setAttribute('style', updated);
    } else {
      el.removeAttribute('style');
    }
  });

  node.querySelectorAll('font[color]').forEach((el) => {
    el.removeAttribute('color');
  });

  return node;
}

function removeInlineColors(html) {
  if (typeof html !== 'string' || html.length === 0) {
    return html;
  }

  const wrapper     = document.createElement('div');
  wrapper.innerHTML = html;
  return removeInlineColorsFromNode(wrapper).innerHTML;
}

function getCropUrl(object) {
  const isCropUrl = url => typeof url === 'string' && url.includes('&src=') && !url.endsWith('&src=undefined');
  if (!object) {
    return null;
  }
  if (isCropUrl(object.croppedHighResPath)) {
    return object.croppedHighResPath;
  }
  return isCropUrl(object.croppedSrc) ? object.croppedSrc : null;
}
export {
  textOverFlowAdjustment, convertingDifferentMeasurementUnitIntoPx, decreaseFontSize, findMaxFont, cmykToHex, rgbToHex, rgbToCmyk, applyLineHeightToEachTag, hexToRgb, getMaxZIndex, helperFunctionToSortByObjectKey, helperFunctionToReverseSortByObjectKey, convertJson2Xml, fetchingSvg, removeBackground, extractSvgColors, blurMaskCache, getBlurMaskBlob, decodeStoredHtml, removeInlineColors, removeInlineColorsFromNode, isFDICEHNCUA, extractSvgSizeFromContent, getSvgScaleToFitBox, applySvgScaleTransform, fitLogoToBox, applyLogoFitFromContent, getCropUrl,
};
